import { render, staticRenderFns } from "./ATV-screen.vue?vue&type=template&id=04a2f129&"
import script from "./ATV-screen.vue?vue&type=script&lang=js&"
export * from "./ATV-screen.vue?vue&type=script&lang=js&"
import style0 from "./ATV-screen.vue?vue&type=style&index=0&id=04a2f129&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports